import styled from 'styled-components'
import { Flex } from 'grid-styled'

import theme from '../../../../../../theme'

export const CardWrapper = styled(Flex)`
  flex-direction: column;
  height: 75vh;
  overflow: auto;
  background-color: #d0e2ef;
  padding: 0 30px 0 30px;
`

export const Title = styled(Flex)`
  color: ${theme.colors.black};
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
  font-size: 40px;
  font-family: Montserrat;
  padding: 15px;
  text-align: center;
`

export const Subtitle = styled(Flex)`
  color: ${theme.colors.navy};
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
  font-size: 18px;
  font-family: Montserrat;
  font-weight: bold;
  padding-bottom: 10px;
`

export const WrapperWrapper = styled.div`
  width: 80%;
  height: 80%;
  max-width: 80vh;
  margin: auto;
`

export const VideoWrapper = styled.div`
  float: none;
  clear: both;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const Description = styled(Flex)`
  color: ${theme.colors.black};
  font-size: 18px;
  font-family: Montserrat;
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 20px;
`



// WEBPACK FOOTER //
// ./src/containers/Music/components/MusicCarousel/components/Card/styles.js